import SalaryRange from './SalaryRange'
export default SalaryRange
